import {
  CLEAR_FORM_HISTORY_MODAL,
  FETCH_FORM_HISTORY_SUCCESS,
  SET_OPEN_FORM_HISTORY_MODAL,
} from '../actions/FormHistoryActions';
import { formatRows } from '../utils/formHistoryUtils';

const initialState = {
  isOpen: false,
  rows: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_OPEN_FORM_HISTORY_MODAL:
      return {
        ...state,
        isOpen: action.isOpen,
      };

    case CLEAR_FORM_HISTORY_MODAL:
      return {
        ...state,
        rows: [],
      };

    case FETCH_FORM_HISTORY_SUCCESS:
      return {
        ...state,
        rows: formatRows(action.rows),
      };

    default:
      return state;
  }
};
